import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SocialShare = ({ article, onShare }) => {
  const [copied, setCopied] = useState(false);

  const shareUrl = `https://giftsy.com/article-detail-page?slug=${article?.slug}`;
  const shareText = `${article?.title} - ${article?.excerpt}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleShare = (platform) => {
    let url = '';
    
    switch (platform) {
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'pinterest':
        url = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(article?.image)}&description=${encodeURIComponent(shareText)}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'width=600,height=400');
    onShare?.(platform);
  };

  return (
    <div className="flex items-center space-x-2">
      <span className="text-sm text-accent-600 mr-2">Share:</span>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleShare('twitter')}
        className="text-accent-600 hover:text-blue-500"
      >
        <Icon name="Twitter" size={16} />
      </Button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleShare('facebook')}
        className="text-accent-600 hover:text-blue-600"
      >
        <Icon name="Facebook" size={16} />
      </Button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleShare('linkedin')}
        className="text-accent-600 hover:text-blue-700"
      >
        <Icon name="Linkedin" size={16} />
      </Button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleShare('pinterest')}
        className="text-accent-600 hover:text-red-500"
      >
        <Icon name="Pinterest" size={16} />
      </Button>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={handleCopyLink}
        className={`text-accent-600 transition-colors ${
          copied ? 'text-success' : 'hover:text-accent-800'
        }`}
      >
        <Icon name={copied ? "Check" : "Link"} size={16} />
      </Button>
    </div>
  );
};

export default SocialShare;